<div id='month-dashboard' class="content">
  <div *ngIf="months && months.length == 0" style="padding: 50px 0px 75px; text-align:center">
    <p>
      <h2>No recent releases found.</h2>
  </div>
  <div id="month-grid" class="dashboard" *ngIf='months && months.length'>
    <div id="cards" class="card-deck justify-content-center">
      <div class="col-lg-3 col-md-6" *ngFor='let month of months'>
        <a [routerLink]="[month.monthYear]">
          <div id={{month.monthYear}} class="card month">
            <img class="card-img-top" [src]="['assets/months/' + month.monthName  + '.png']" [alt]="[month.monthName + 'Image']">
            <div class="card-body">
              <p class="card-title">{{month.monthName + ' ' + month.yr}}</p>
            </div>
            <div class="card-footer">
              <small class="text-muted">Latest: {{month.lastReleaseDate | date: "MM-dd-yyyy"}} | Ver. {{month.latestVersion}}</small>
            </div>
          </div>
        </a>
      </div>
    </div>
  </div>
  <div class="container col-md-4 mx-auto" *ngIf="older && older.length > 0" style="padding: 50px 0px 75px; text-align:center">
    <p>
      <button class="btn btn-link" type="button" (click)="isCollapsed = !isCollapsed"
      [attr.aria-expanded]="isCollapsed" aria-controls="#olderlist">
        View Older Releases
      </button>
    </p>
    <div id="olderlist" [ngbCollapse]="!isCollapsed">
      <ul>
        <li *ngFor='let mon of older'>
          <a [routerLink]="[mon.monthYear]">{{mon.monthName}} {{mon.yr}} (Version: {{mon.latestVersion}})</a>
        </li>
      </ul>
    </div>
  </div>
</div>
